export default "__VITE_ASSET__HeKEp7Jk__"